import { render, staticRenderFns } from "./tribe-box-category.vue?vue&type=template&id=789a349c&scoped=true&"
import script from "./tribe-box-category.vue?vue&type=script&lang=js&"
export * from "./tribe-box-category.vue?vue&type=script&lang=js&"
import style0 from "./tribe-box-category.vue?vue&type=style&index=0&id=789a349c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a349c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789a349c')) {
      api.createRecord('789a349c', component.options)
    } else {
      api.reload('789a349c', component.options)
    }
    module.hot.accept("./tribe-box-category.vue?vue&type=template&id=789a349c&scoped=true&", function () {
      api.rerender('789a349c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/tribe-box-category.vue"
export default component.exports